import utils from '../../foundation/utils'
class AssessTask
{
  constructor(task)
  {
    this._task = task;
  }
  get taskUrl()
  {
    return this._task.task_url;
  }
  finishAssessmentTask(task_uri)
  {
    let json = {
      task_uri,
    }
    let fetchOptions = {
      method: 'POST',
      body: utils.j2t(json),
      headers:{
        Authorization: `Bearer ${localStorage.access_token}`,
      },
    };
    return fetch('/api/v2/forms/finish-assessment', fetchOptions);
  }
};

let createTask = (template_uri, patient)=>
{
  let json = {
    template_uri,
    owner: 'dummy',
    case_id: patient
  }
  let fetchOptions = {
    method: 'POST',
    body: utils.j2t(json),
    headers:{
      Authorization: `Bearer ${localStorage.access_token}`,
    },
  };
  return fetch('/api/v2/forms/new-assessment', fetchOptions)
    .then((r)=>r.json())
    .then((j)=> new AssessTask(j));
};
export default {
  createTask,
}



// WEBPACK FOOTER //
// ./src/bz/assess-task/index.js